import * as React from "react";
import * as moment from "moment";
import { connect } from "react-redux";

class HoraActual extends React.Component<any, any> {

    constructor(props: any) {
        super(props);

        this.state = {
            hora: moment(new Date()).format('DD/MM/Y - hh:mm:ss A')
        };
    }

    componentDidMount() {
        setInterval(
            () => this.acualizarHora(),
            1000
        );
    }

    acualizarHora() {
        this.setState({
            hora: moment(new Date()).format('DD/MM/Y - hh:mm:ss A')
        });
    }

    render() {
        return (
            <div>
                Fecha actual: {this.state.hora}
            </div>
        );
    }
}

export default connect((store: any, props: any) => {
    return {
        ...props
    };
})(HoraActual);


// WEBPACK FOOTER //
// ./src/co/sura/dominio/general/componentes/HoraActual.tsx